module.exports = __webpack_public_path__ + "static/india-2bcfacf0be0efd19f89a6f1f3aadc391.png";